import React from "react";
import "./BrandSlider.css";

// Import brand logos from assets
import brand1 from "../assets/logobags_page-0001.jpg";
import brand2 from "../assets/logobags_page-0002.jpg";
import brand3 from "../assets/logobags_page-0003.jpg";
import brand4 from "../assets/logobags_page-0004.jpg";
import brand5 from "../assets/logobags_page-0005.jpg";
import brand6 from "../assets/logobags_page-0006.jpg";
import brand7 from "../assets/logobags_page-0007.jpg";
import brand8 from "../assets/logobags_page-0008.jpg";

const BrandSlider = () => {
  const brands = [brand1, brand2, brand3, brand4, brand5, brand6, brand7, brand8];

  return (
    <div className="brand-grid-container">
      <h2 className="brand-grid-title">Shop by Brands</h2>
      <div className="brand-grid">
        {brands.map((brand, index) => (
          <div key={index} className="brand-card">
            <img src={brand} alt={`Brand ${index + 1}`} className="brand-logo" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandSlider;